import {ValueObject} from '@s-ui/domain'

export class WdylAdsValueObject extends ValueObject {
  /**
   * @param {Object} newVehiclesValueObject
   * @param {Object} rentingVehiclesValueObject
   * */
}
